import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

import {
    type ErrorStruct,
    getRecruitmentQueryKey,
    getUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey,
    usePutUserRequestsId,
} from '@/shared/api'
import { PAGE_SIZE } from '@/shared/model'

export const useRequestSaveDraft = (requestPublicId: string) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()

    const { mutateAsync: saveDraft, isPending } = usePutUserRequestsId({
        mutation: {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: getRecruitmentQueryKey({
                        limit: PAGE_SIZE,
                        offset: 0,
                    }),
                })

                await queryClient.invalidateQueries({
                    queryKey:
                        getUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey(requestPublicId),
                })

                toast.success(`Заявка №${requestPublicId} обновлена`)
                navigate({ to: '/requests/$id', params: { id: requestPublicId } })
            },
            onError: (error) => {
                const { error_message } = error as ErrorStruct
                toast.error(`Не удалось сохранить заявку №${requestPublicId}: ${error_message}`)
                throw error
            },
        },
    })

    return {
        saveDraft,
        isPending,
    }
}
